import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogIn, Flame } from "lucide-react";
import { useAdminAuth } from "@/hooks/useAdminAuth";

export default function AdminLoginPage() {
  const auth = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!auth.loading && auth.user && auth.isAdmin) nav("/admin/dashboard");
  }, [auth, nav]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await auth.signIn(email, password); }
    catch (e) { setError(e instanceof Error ? e.message : "Login failed."); }
    finally { setBusy(false); }
  }

  return (
    <main className="min-h-screen flex items-center justify-center px-4 py-8">
      <form onSubmit={submit} className="card-dark p-6 max-w-sm w-full space-y-4">
        <div className="flex items-center gap-2 text-white font-display text-xl">
          <Flame className="w-5 h-5 text-forge-400" /> WeldQuest Manager
        </div>
        <div>
          <label className="label" htmlFor="adm-email">Email</label>
          <input id="adm-email" type="email" required className="input"
            value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
        </div>
        <div>
          <label className="label" htmlFor="adm-pw">Password</label>
          <input id="adm-pw" type="password" required className="input"
            value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </div>
        {error && <div className="pill-bad px-3 py-2">{error}</div>}
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} Sign in
        </button>
        <p className="text-xs text-steel-400">
          You must be added to <code>public.admin_users</code> in Supabase to access the dashboard.
        </p>
      </form>
    </main>
  );
}
